import cn from 'classnames';
import { Text } from '../../../Basic/WrapsStyle';
import styles from './styles.module.scss';

const PostingStatusWrap = ({ order = false, children }) => {
  return (
    <div
      className={cn(
        styles.status,
        order.status === 'Ожидает отгрузки' && styles.process,
        order.status === 'Не принят на CЦ' && styles.waiting,
        order.status === 'Идёт приёмка' && styles.waiting,
        order.status === 'Доставляется' && styles.sorted,
        order.status === 'Прибыл на ПВЗ' && styles.pickup,
        order.status === 'Продано' && styles.sold,
        // order.status === 'Продано' && order.products[0]?.commission?.increased_commission?.from_report && styles.sold_report,
        order.status === 'Доставлено' && styles.sold,
        order.status === 'Отменено' && styles.canceled,
        order.status === 'Отменено клиентом' && styles.controversial,
        order.status === 'Арбитраж' && styles.controversial,
        order.status === 'Обнаружен брак' && styles.waiting,
        order.status === 'Неопознанный товар' && styles.waiting,
        (order.status === 'Отменено' && order.cancellation.is_cancel_after_sale) && styles.canceled_after_sale,
        order.cancellation?.is_return && styles.return,
      )}
    >
      {order.status}
      <Text fontWeight="600" style={{ color: 'inherit' }}>
        {order.cancellation?.is_return && 'Возврат'}
      </Text>
      {children}
    </div>
  );
};

export default PostingStatusWrap;
